import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { SwalService } from 'src/app/core/services/swal.service';
import swal from 'sweetalert2';
import { ExcelService } from 'src/app/core/services/excel.service';
import { LocalStorageService } from 'ngx-webstorage';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppConfigService } from '../../../../../../core/services/config.service';

@Component({
    selector: 'app-competences-reporting',
    templateUrl: './competences.component.html',
    styleUrls: ['./competences.component.css']
})
export class CompetencesComponent implements OnInit {
    direction: any;
    selectedDirection: any;
    selectedStructure: any;
    settingsDirection = {};
    settingsStructure = {};
    listDirection: any = [];
    listStructure: any = [];
    matricule: any;
    listAgent: any;
    nbre_agents: any;
    vueListAgent = false;
       key = 'nom';
    reverse = false;
    p = 1;
    filter: string;
    id_direction: any;
    code_direction: any;
    id_structure: any;
    code_structure: any;
    response: any;
    constructor(
        private _service: AppService,
        private toastrService: ToastrService,
        private _loader: LoadingBarService,
        private _excelService: ExcelService,
        private _swal: SwalService,
        private _router: Router,
        private storage: LocalStorageService,
        private configService: AppConfigService,
        private title: Title
    ) { }

    ngOnInit() {
        this.getAllDirection();
        this.title.setTitle('Reporting EIA | HR Performance');
        this.settingsDirection = {
            singleSelection: true,
            text: 'Selectionner la direction',
            classes: 'myclass custom-class',
            labelKey: 'code',
            enableSearchFilter: true,
            searchBy: ['code'],
            searchPlaceholderText: 'Rechercher',
            noDataLabel: 'Aucune direction disponible'
        };

        this.settingsStructure = {
            singleSelection: true,
            text: 'Selectionner la structure',
            classes: 'myclass custom-class',
            labelKey: 'code',
            enableSearchFilter: true,
            searchBy: ['code'],
            searchPlaceholderText: 'Rechercher',
            noDataLabel: 'Aucune structure disponible'
        };
    }

    ouvrirFiche(data, type_fiche, type_sauvegarde, category) {
        // tslint:disable-next-line: max-line-length
        this._router.navigateByUrl(`campagne/reporting-eia/agent/${data?.id}/${data?.agent_id}/type_fiche/${type_fiche}/type_sauvegarde/${type_sauvegarde}/${category}/statut/approuvé`);
    }

    getAllDirection() {
        this._loader.start();
        this._service.getData('capital-humain/structures/direction')
            .subscribe(
                res => {
                    if (res.error === false) {
                        this._loader.stop();
                        this.listDirection = res.data;
                    } else {
                        this._loader.stop();
                        this._swal.error(res.message);
                    }
                }, err => {
                    this._loader.stop();
                    this.toastrService.error(err.error.message);
                }
            );
    }

    // Get all structure
    getAllStructure(idDirection) {
        this._loader.start();
        this._service.getData('capital-humain/structures/' + idDirection + '/structure-of-direction').subscribe((data: {}) => {
            this._loader.stop();
            this.response = data;
            this.listStructure = this.response.data;
        });
    }

    onSelectDirection(item) {
        this.id_direction = item.id;
        this.code_direction = item.code;
        this.getAllStructure(item.id);
    }

    onSelectStructure(item) {
        this.id_structure = item.id;
        this.code_structure = item.code;
    }

    onDeSelectItem(item, type) {
        if (type === 'direction') {
            this.id_direction = '';
            this.code_direction = '';
        } else {
            this.id_structure = '';
            this.code_structure = '';
        }
    }

    downloadCompetencesByAgent(data) {
        this._loader.start();
        const arrayCompetences = [];
        for (let i = 0; i < data.competences.length; i++) {
            arrayCompetences.push(
                {
                    'Code': data.competences[i].code,
                    'Compétence': data.competences[i].competence,
                    'Delai urgence': data.competences[i].delai_urgence,
                    'Niveau compétence réel': data.competences[i].niveau_competence_reel,
                    'Niveau competence requis': data.competences[i].niveau_competence_requis,
                    'Niveau urgence': data.competences[i].niveau_urgence
                }
            );
        }
        this._excelService.exportAsExcelFile(arrayCompetences, 'liste_competences_' + data.nom + '_' + data.prenoms);
        this._loader.stop();
    }

    exportXls() {
        this._loader.start();
        const arrayAgent = [];
        for (let i = 0; i < this.listAgent.length; i++) {
            arrayAgent.push(
                {
                    'Matricule': this.listAgent[i].matricule,
                    'Nom & Prénoms': this.listAgent[i].nom + ' ' + this.listAgent[i].prenoms,
                    'Direction': this.listAgent[i].direction,
                    'Service': this.listAgent[i].service,
                    'Section': this.listAgent[i].section,
                    'Sous-Section': this.listAgent[i].sous_section,
                    'Tenue de poste': this.listAgent[i].resultat_synthese_competence,
                    'Performance': this.listAgent[i].resultat_synthese_performance,
                    'Resultat global': this.listAgent[i].resultat_global,
                    'Appréciation global': this.listAgent[i].appreciation_global
                }
            );
        }
        this._excelService.exportAsExcelFile(arrayAgent, 'reporting_recherche_agent');
        this._loader.stop();
    }

    rechercher() {
        this._loader.start();
        const obj = {
            campagne_id: this.storage.retrieve('idCampagneEiaSelected'),
            code_direction: this.code_direction,
            code_structure: this.code_structure,
            matricule: this.matricule,
        };
        this._service.postData('reporting/get_competence_reporting', obj).subscribe(
            (res) => {
                if (res.error === false) {
                    this._loader.stop();
                    this.listAgent = res.data;
                    this.nbre_agents = this.listAgent.length;
                    if (this.listAgent.length <= 0) {
                      const sigle = this.configService.get('SIGLE');
                      let title;
                      if (sigle === 'SMB') {
                        title = 'HR PERF';
                      } else if (sigle === 'SIR') {
                        title = 'HR PERF';
                      }
                      swal.fire({
                            title: title,
                            type: 'warning',
                            text: 'Aucune donnée disponible',
                            showCancelButton: false,
                            confirmButtonText: 'ok',
                        });
                    } else {
                        this.vueListAgent = true;
                    }
                } else {
                    swal.fire({
                        title: 'HR PERF',
                        type: 'warning',
                        text: res.message,
                        showCancelButton: false,
                        confirmButtonText: 'ok',
                    });
                    this._loader.stop();
                    this.vueListAgent = false;
                }
            },
            (err) => {
                this.toastrService.error(err.error.message);
                this._loader.stop();
                this.vueListAgent = false;
            }
        );
    }

}
